import { render, staticRenderFns } from "./UiChoiceModal.vue?vue&type=template&id=369e8fe0&scoped=true"
import script from "./UiChoiceModal.vue?vue&type=script&lang=js"
export * from "./UiChoiceModal.vue?vue&type=script&lang=js"
import style0 from "./UiChoiceModal.vue?vue&type=style&index=0&id=369e8fe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369e8fe0",
  null
  
)

export default component.exports